<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.home.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <ul class="report-link-list" data-testid="report-links">
        @for (report of reports; track report.path) {
          <li>
            <a [routerLink]="report.path" class="report-link" [attr.data-testid]="'report-link-' + report.path">
              <app-icon name="chart-no-axes-column-increasing" [size]="18" />
              <div class="flex flex-column">
                <span class="report-link-title">{{ report.labelKey | translate }}</span>
                <span class="report-link-desc">{{ report.descriptionKey | translate }}</span>
              </div>
            </a>
          </li>
        }
      </ul>
    </app-card-content>
  </app-card>
</div>
